import * as types from './labels.types';
export const labelsPageSelectors: types.ILabelPageSelectors = {
  selectLabels: (state) => state.page.labels.labelsIds,
};
